// Interruptor para ver el banner en cualquier búsqueda mientras se ajusta el diseño.
// En true ignora país, filtros y ubicación, así que el banner deja de ocultarse: dejar
// en false salvo que se esté trabajando sobre el diseño.
export const FORCE_SHOW_BANNER = false;

// El banner cubre todo el departamento de Maldonado: además del filtro por
// departamento, engloba Punta del Este, Piriápolis, Punta Colorada, La Barra,
// Manantiales, El Chorro, Balneario Buenos Aires y José Ignacio. UUID verificado
// contra el payload del search-service; si en otro entorno fuera distinto, el match
// por nombre de abajo sigue cubriendo el caso.
export const MALDONADO_STATE_ID: number | string | null =
	"347a862d-48cc-4041-bf02-f4777d1cdf0b";

const MALDONADO_NAME = "maldonado";
const COUNTRY = "UY";

const normalize = (value?: string | null) => {
	if (!value) return "";
	return value
		.normalize("NFD")
		.replace(/[̀-ͯ]/g, "")
		.toLowerCase()
		.replace(/\s+/g, " ")
		.trim();
};

const toArray = value => {
	if (!value) return [];
	return Array.isArray(value) ? value : [value];
};

// El id cubre un cambio de nombre desde el backend; el nombre cubre un entorno donde
// el id sea otro. Se compara por igualdad y no por "incluye": una localidad puede
// llamarse "Maldonado" y es válida, pero no queremos que "Maldonado" aparezca dentro
// de otro nombre y dé un falso positivo.
const isMaldonado = (node, stateId): boolean => {
	if (!node) return false;
	if (stateId != null && String(node.id) === String(stateId)) return true;
	return normalize(node.name) === MALDONADO_NAME;
};

// Una location de tipo STATE trae estate apuntando a sí misma y una localidad trae el
// departamento que la contiene, así que mirar estate resuelve los dos casos con una
// sola regla. Se chequea igual el propio item por si algún payload viniera sin estate.
const isInMaldonado = (item, stateId): boolean => {
	if (!item) return false;
	return isMaldonado(item.estate, stateId) || isMaldonado(item, stateId);
};

export const shouldShowPuntaDelEsteBanner = ({
	country_code,
	filters,
	filtersTags,
	stateId = MALDONADO_STATE_ID,
	forceShow = FORCE_SHOW_BANNER,
}): boolean => {
	if (forceShow) return true;

	if (country_code !== COUNTRY) return false;
	if (!filters || filters.projects !== true) return false;

	// filtersTags.locations puede venir como objeto suelto o como array, y cada
	// entrada agrupa sus ubicaciones en .value (ver LocationTagsHolder).
	return toArray(filtersTags?.locations).some(location =>
		toArray(location?.value).some(item => isInMaldonado(item, stateId))
	);
};
